import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import api from '../../utils/api';

// Async thunk for fetching advisor data
export const fetchAdvisorData = createAsyncThunk(

  'advisor/fetchAdvisorData',
  async (advisorId, { rejectWithValue }) => {
    try {
      const response = await api.get(`advisor/get_advisor_data/${advisorId}`);
      console.log("Fetched Advisor Data:", response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const advisorSlice = createSlice({
  name: 'advisor',
  initialState: {
    advisorData: {},
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdvisorData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAdvisorData.fulfilled, (state, action) => {
        state.loading = false;
        state.advisorData = action.payload;
      })
      .addCase(fetchAdvisorData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default advisorSlice.reducer;
